'use client';
import type { FC } from 'react';
import { BaseFillLike } from '@/app/components/icons/BaseFillLike';
import { BaseLineLike } from '@/app/components/icons/BaseLineLike';
import type { ButtonProps } from '@/app/components/ui/button';
import type { CommunityEnum, UpdateInteractionStatusFn } from '@/app/types';
import { cn } from '@/app/utils';
import CountButton from '../CountButton';

interface LikeButtonProps {
  id: string;
  itemVote: boolean;
  itemVoteCount: number;
  tabType: CommunityEnum;
  className?: string;
  traceId?: string;
  handleVote?: UpdateInteractionStatusFn;
  handleUnVote?: UpdateInteractionStatusFn;
  iconClassName?: string;
  numClassName?: string;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  hideEmptyVoteCount?: boolean;
}

const LikeButton: FC<LikeButtonProps> = ({
  id,
  itemVote,
  tabType,
  itemVoteCount,
  className,
  traceId,
  handleVote,
  handleUnVote,
  iconClassName,
  numClassName,
  size = 'original',
  variant = 'text',
  hideEmptyVoteCount = false,
}) => {
  return (
    <CountButton
      className={className}
      count={itemVoteCount}
      active={itemVote}
      size={size}
      variant={variant}
      numClassName={numClassName}
      handleUnActive={() => {
        handleUnVote?.({ id, obj_type: tabType, traceId: traceId || '' });
      }}
      handleActive={() => {
        handleVote?.({ id, obj_type: tabType, traceId: traceId || '' });
      }}
      hideEmptyCount={hideEmptyVoteCount}
      activeIcon={<BaseFillLike className={cn('text-xl', iconClassName)} />}
      unActiveIcon={<BaseLineLike className={cn('text-xl', iconClassName)} />}
    />
  );
};

export default LikeButton;
